export const DTModalHeaderInjector = Symbol()
export const DTDropdownItemInjector = Symbol()
